//External libs
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

//Local libs
import Service from 'src/app/core/services/service';
import ClimateParamsModel from '../models/climate-params.model';

/**
 * @service ClimateParamsService
 * @description Service for managing climate parameter data.
 * Provides HTTP methods for retrieving climate data (temperature, humidity, etc.)
 * associated with specific ponds and dates.
 * Extends base Service class with generic type ClimateParamsModel.
 *
 * @feature 1. Fetch climate parameters by pond ID and date
 * @feature 2. Cancel ongoing HTTP requests
 *
 * @architecture
 * Extends base Service<ClimateParamsModel>. Provides access to historical or current
 * climate data stored for aquaculture ponds.
 *
 * @service-endpoint /aqu/climateparams/
 * @service-provider root (singleton, application-wide)
 *
 * @author AquaCloud Development Team
 * @version 1.0.0
 */
@Injectable({
  providedIn: 'root'
})
export class ClimateParamsService extends Service<ClimateParamsModel> {

  /**
   * @type {Array<Subscription>}
   * @description Array tracking all ongoing HTTP request subscriptions
   * @default []
   * @side-effect Used to store subscription references for cancellation via cancelOnGoingHttpRequests()
   */
  public ongoingRequests: Subscription[] = [];

  /**
   * @method constructor
   * @description Service constructor with dependency injection of HttpClient
   *
   * Initializes service by calling parent Service constructor with baseUrl
   * configuration and service endpoint path.
   *
   * @param {HttpClient} httpClient - @service Angular HTTP client for making HTTP requests
   * @returns {void}
   */
  constructor(public httpClient: HttpClient) {
    super(httpClient, '/aqu/climateparams/');
  }
}
